{
  "Clear search": "검색 지우기"
}
